import React from 'react'
import axios from 'axios'

export const ApiContext = React.createContext(axios.create())
